import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styles from "../thema/style";
import ProductItem from "./ProductItem";
import activeDiscount from "../helpers/activeDiscount";
import calculatePrice from "../helpers/calculatePrice";

import Loading from "./shared/Loading";
import { connect } from "react-redux";
import { recentlyAddedProducts } from "../store/actions/product";
import CartItem from "./CartItem";

class CheckoutCart extends Component {
  // this.props.order.order.products
  render() {
    const cartTotalDiscountPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((product) =>
                parseFloat(
                  calculatePrice(product, activeDiscount(product.categories))
                )
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    const cartTotalPrice =
      this.props.cart.items.length > 0
        ? parseFloat(
            this.props.cart.items
              .map((item) =>
                item.sale_price
                  ? item.quantity * item.sale_price
                  : item.quantity * item.price
              )
              .reduce((a, b) => a + b)
              .toFixed(2)
          )
        : 0;

    return (
      <React.Fragment>
        <div style={{ marginTop: 10, width: "100%" }}>
          {this.props.header ? (
            <React.Fragment>
              <h3>Siparişi Onayla</h3>
              <span>Sipariş özetiniz aşağıdaki gibidir.</span>
            </React.Fragment>
          ) : null}
          <table className={styles.cartDetail}>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>RESİM</th>
                <th>ÜRÜN ADI</th>
                <th className="product-price">BİRİM FİYATI</th>
                <th>MİKTAR</th>
                <th className="product-subtotal">TOPLAM</th>
                <th className="product-remove">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              {this.props.cart.items.map((item, i) => (
                <CartItem
                  key={i}
                  product={item}
                  updateCartQuantity={(quantity) => {
                    this.props.updateCartQuantity(item, quantity);
                  }}
                  removeCart={() => {
                    this.props.removeCart(item);
                  }}
                  incCart={() => {
                    this.props.incCart(item);
                  }}
                  decCart={() => {
                    this.props.decCart(item);
                  }}
                />
              ))}
            </tbody>
            {this.props.cart.items.length !== 0 ? (
              <tfoot>
                <tr>
                  <td className={"text-right"} colSpan={5}>
                    <strong>Ara Toplam:</strong>
                  </td>
                  <td className={"text-center"}>
                    ₺{parseFloat(cartTotalPrice).toFixed(2)}
                  </td>
                </tr>
                {/* {cartTotalPrice > 0 ? (
                    <div>
                      Kargo:{" "}
                      <span>₺{this.props.setting.setting.shipping_cost}</span>
                    </div>
                  ) : null} */}
                {cartTotalDiscountPrice > 0 ? (
                  <tr>
                    <td className={"text-right"} colSpan={5}>
                      <strong>Kargo:</strong>
                    </td>
                    <td className={"text-center"}>
                      ₺
                      {parseFloat(
                        this.props.setting.setting.shipping_cost
                      ).toFixed(2)}
                    </td>
                  </tr>
                ) : null}

                {cartTotalDiscountPrice >=
                this.props.setting.setting.free_shipping ? (
                  <tr>
                    <td className={"text-right"} colSpan={5}>
                      <strong>
                        {parseFloat(
                          this.props.setting.setting.free_shipping
                        ).toFixed(2)}{" "}
                        TL ve Üzeri Ücretsiz Kargo
                      </strong>
                    </td>
                    <td
                      className={"text-center"}
                      style={{ color: "rgb(205 26 52)" }}
                    >
                      -₺
                      {parseFloat(
                        this.props.setting.setting.shipping_cost
                      ).toFixed(2)}
                    </td>
                  </tr>
                ) : null}

                {cartTotalPrice - cartTotalDiscountPrice > 0 ? (
                  <tr>
                    <td className={"text-right"} colSpan={5}>
                      <strong>Sepette İndirim</strong>
                    </td>
                    <td
                      className={"text-center"}
                      style={{ color: "rgb(205 26 52)" }}
                    >
                      -₺
                      {parseFloat(
                        cartTotalPrice - cartTotalDiscountPrice
                      ).toFixed(2)}
                    </td>
                  </tr>
                ) : null}

                <tr>
                  <td className={"text-right"} colSpan={5}>
                    <strong>Toplam:</strong>
                  </td>
                  <td className={"text-center"}>
                    ₺
                    {parseFloat(
                      cartTotalDiscountPrice > 0
                        ? cartTotalDiscountPrice +
                            (cartTotalDiscountPrice >=
                            this.props.setting.setting.free_shipping
                              ? 0
                              : this.props.setting.setting.shipping_cost)
                        : 0
                    ).toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            ) : null}
          </table>

          <p className={"text-right"} style={{ fontWeight: "bold" }}>
            {cartTotalDiscountPrice > 0 ? (
              this.props.setting.setting.free_shipping < 0 ? (
                "Tüm alışverişlerde kargoyu alıcı öder."
              ) : cartTotalDiscountPrice <
                this.props.setting.setting.free_shipping ? (
                <React.Fragment>
                  {parseFloat(this.props.setting.setting.free_shipping).toFixed(
                    2
                  )}{" "}
                  TL ve Üzeri Ücretsiz Kargo
                  <br />
                  Ücretsiz Kargo olması için{" "}
                  {parseFloat(
                    this.props.setting.setting.free_shipping -
                      cartTotalDiscountPrice
                  ).toFixed(2)}{" "}
                  TL daha ürün ekleyin.
                </React.Fragment>
              ) : null
            ) : null}
          </p>
        </div>
        <hr />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ setting, cart }) => {
  return { setting, cart };
};

const mapDispatchToProps = {
  recentlyAddedProducts,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutCart);



// WEBPACK FOOTER //
// ./src/components/CheckoutCart.js